import { Box, CircularProgress, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface ILoaderProps {
  size?: number
  isStatic?: boolean
}

interface ILoaderWithTextProps {
  text: ReactNode
  size?: number
}

export const Loader = ({ size = 40, isStatic = false }: ILoaderProps) =>
  isStatic ? (
    <CircularProgress
      size={size}
      // sx={{ color: 'white' }}
    />
  ) : (
    <div
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: size,
        height: size,
      }}
    >
      <CircularProgress size={size} />
    </div>
  )

export const LoaderWithText = ({ text, size = 40 }: ILoaderWithTextProps) => (
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
    }}
  >
    <CircularProgress size={size} />
    {text}
  </Box>
)
